import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
export const isConstructorParameterDefault = (node) => {
    const parent = tsUtils.node.getParent(node);
    if (parent === undefined || !ts.isParameter(parent)) {
        return false;
    }
    const parentParent = tsUtils.node.getParent(parent);
    return ts.isConstructorDeclaration(parentParent);
};

//# sourceMappingURL=isConstructorParameterDefault.js.map
